import {Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { Router } from '@angular/router';
import { APIService } from 'src/app/api.service';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
//import { ProductionJobCreationComponent } from '../../../production/production-job-creation/production-job-creation.component'
 

@Component({
  selector: 'app-stock-analysis',
  templateUrl: './stock-analysis.component.html',
  styleUrls: ['./stock-analysis.component.scss']
})
export class StockAnalysisComponent implements OnInit {

  //displayedColumns: string[] = ['ItemName','categoryName','subCategoryName','DispatchQty','consumption','ProductionQty','InwardQty','ReconciliationQty','Unit'];
  displayedColumns: string[] = ['ItemName', 'minStock', 'pndgSOQty', 'currentStock', 'pndgPOQty', 'pndgPrdJobQty', 'planQty', 'shortfall', 'SKU', 'currentLevel', 'leadTime', 'Actions'];

 dataSource = new MatTableDataSource();

  curDate: any = new Date();
  months: any = [];
  monthDisplay: any = [];
  agencyData: any;
  jarvisData: any;
  type:any =  "MM";
  month = this.curDate.getMonth();
  year = this.curDate.getFullYear();
  stockAnalysisData: any;
  origStockData: any;
  tagData: any= [];
  categories: any;
  subCategories: any= [];
  ERP_Agn: any = [];
  financialYears: any = [];
  exportToExcel: any = [];
  display: string = '';
  rptType: any = ''; // 1 = low-stock, 2 = purch plan, 3 = mfg plan
  reportTitle: string = 'Low-Stock Items';
  selectedFilter: any = { // all filters
      categoryID: 0,
      category: '',
      subCategoryID: 0,
      subCategory:'',
      perStockLevel:0,
      importanceID: 3,
      importance: '',
      source: 0,
      type: 0,
      stockLevelSel: false,
      stockLevel: 100
    }
  period = 0;
  search: string = '';
  userRights: any = [];
  storeList: any = [];
  showItemSummary: boolean = false;
  view = {
    month: (this.curDate.getMonth() + 1).toString(),
    year: (this.curDate.getFullYear()).toString(),
    fy : '',
  }
  isWeb: boolean = true;

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  @ViewChild(MatPaginator) 
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  } 
  
  constructor(private router: Router,  private commonService: CommonService, private apiService: APIService, public commonFun: CommonService, private modalService: NgbModal) { }
  
  ngOnInit(): void {
    
    this.months = this.commonService.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date().customFormat("#DD#-#MMM#-#YY#"));
    this.monthDisplay = this.months[this.months.length - 1].display;
  
    
    this.financialYears = this.commonService.checkFinancialYear(new Date('2019-Apr-01'), new Date());

    let jarvis: any = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    
    let agencyData = this.apiService.getCookie('M');
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
    }

    let storeList = this.apiService.getCookie('ERP_Cfg');
    if (storeList) {
      this.storeList = JSON.parse(storeList);
      this.storeList = JSON.parse(this.storeList[0].Stores);      
    }

    let usersData = this.apiService.getCookie("J");
    if (usersData) {
      this.userRights = JSON.parse(usersData);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.userRights = $.grep(this.userRights, function (o: any) { return o.UserID == ownUserID })[0];
      this.userRights.JobView = (this.ERP_Agn[0].EnblProduction && (this.userRights.Prd || this.userRights.PrdCfg || this.userRights.PrdRpts)) ? true : false;
    }

    let myStores: any = [];
    if(this.jarvisData[0].UserID != this.ERP_Agn[0].AdminUserID) {
      for(let i: number = 0; i < this.storeList.length; i++) {
        if(this.storeList[i].UIDs) {
          let selectedUsers = String(this.storeList[i].UIDs).split(",");
          for(let j: number = 0; j < selectedUsers.length; j++) {
            if(selectedUsers[j] == this.jarvisData[0].UserID){
              myStores.push(this.storeList[i]);
            }
          }                
        }
        else{
          myStores.push(this.storeList[i]);
        }
        if(myStores.length == this.storeList.length) {
          this.userRights.allStoreRights = true;
        }
        else {
          this.userRights.allStoreRights = false;
        }
      }    
    }      

    if(this.userRights.InvRpts && this.userRights.SOViewTypeID > 0 && this.userRights.POView && this.userRights.JobView && this.userRights.allStoreRights) {
      this.showItemSummary = true;
    }

    let getParam =  this.commonFun.GetParam("r");

    this.rptType = getParam ? getParam : 1; // default low-stock 
    this.reportTitle = this.rptType == 1 ? 'Stock Shortfall Report' : (this.rptType == 2 ? 'Purchase Requirement Analysis' : (this.rptType == 3 ? 'Manufacturing Requirement Analysis': ''));  
    this.getStockData();
  }


  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
      , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

    return function (table: any, name: string, fileName: any) {
      if (!table.nodeType) table = table
      var ctx = { worksheet: name || 'Worksheet', table: table }
      var link = document.createElement("a");
      link.download = fileName || 'download.xls';
      link.href = uri + base64(format(template, ctx));
      link.click();
    }
  })()

  getStockData() {
      let data = [
        {
          Month: this.view.month,
          Year: this.view.year,
          Type: this.type,
        },
      ];
      let myParams = [
        {
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          myLastSyncDT: null,
          isWeb: true,
          ForERPAgencyID: this.agencyData[0].ERPAgencyID,
          actionType: 'getStockAnalysis',
          moduleID: 12,
          data: JSON.stringify(data),
        },
      ];
  
      this.apiService.getData(myParams, this.stockAnalysisSuccessResp.bind(this), this.stockAnalysisFailureResp.bind(this)
      );
    }
  
  stockAnalysisSuccessResp(res: any) {
      // this.SpinnerService.hide();
      if (res.error) {
      }
      else {
        if (res) {
          var reponseData = JSON.parse(res.updatePackage);
          if (reponseData.Table[0].ErrCode == 1000) {
            alert(reponseData.Table[0].ErrMsg);
          } else {
            if (reponseData.Table[0].ErrCode == -1) {
              this.stockAnalysisData = reponseData.Table1;

              let tmpERP_Cfg = this.apiService.getCookie("ERP_Cfg");
              if(tmpERP_Cfg){
                this.tagData =  JSON.parse(tmpERP_Cfg);
                if(this.tagData){
                  this.categories = JSON.parse(this.tagData[0].ItemCategories);
                 
                }
              }
            
            
              this.stockAnalysisData.forEach((stockItem: any) => {
                // category & sub-category
                let CatData = this.categories.filter((x: any) => x.cid == stockItem.CategoryID);
                if(CatData.length > 0){
                  stockItem.categoryName = CatData[0].cnm;
                  if (CatData[0].sub) {
                    let subCategoryList = (CatData[0].sub);
                    let subCat = subCategoryList.filter((x: any) => x.sid == stockItem.SubCategoryID);
                    if(subCat.length > 0) {
                      stockItem.subCategoryName = subCat[0].snm ? subCat[0].snm : '';
                    }
                  }
                }

                stockItem.hasDiffUnits = false;
                let soUnits = stockItem.SOUnits.split(',');
                for(let unit of soUnits) {
                  if(unit != '' && stockItem.SKU != unit) {
                    stockItem.hasDiffUnits = true;
                    break;
                  }
                }

                let poUnits = stockItem.POUnits.split(',');
                for(let unit of poUnits) {
                  if(unit != '' && stockItem.SKU != unit) {
                    stockItem.hasDiffUnits = true;
                    break;
                  }
                }

                //process stock analysis data
                stockItem.minStock = Number(stockItem.MinStockQty).toFixed(stockItem.SKUPrecision)
                stockItem.currentStock = Number(stockItem.CurrQty).toFixed(stockItem.SKUPrecision)
                if (stockItem.minStock > 0) {
                  let stockLevel = (stockItem.currentStock * 100)/stockItem.minStock;
                  stockItem.currentLevel = Math.round(stockLevel);
                }
                else {
                  stockItem.currentLevel = 0;
                }
                stockItem.leadTime = stockItem.LeadTime;
                stockItem.pndgPOQty = Number(stockItem.PndgPOQty).toFixed(stockItem.SKUPrecision);
                stockItem.pndgSOQty = Number(stockItem.PndgSOQty).toFixed(stockItem.SKUPrecision);
                stockItem.pndgPrdJobQty = Number(stockItem.PndgPrdJobQty).toFixed(stockItem.SKUPrecision);
                stockItem.planQty = Number(stockItem.PlanQty).toFixed(stockItem.SKUPrecision);
                stockItem.shortfall = Number(Number(stockItem.PndgSOQty) - Number(stockItem.PndgPOQty) - Number(stockItem.PndgPrdJobQty) - Number(stockItem.CurrQty) + Number(stockItem.MinStockQty) + Number(stockItem.PlanQty)).toFixed(stockItem.SKUPrecision);
            });

              this.dataSource.data = this.stockAnalysisData;
              this.exportToExcel = this.stockAnalysisData;
              this.origStockData = this.stockAnalysisData;
              this.dataSource.sort = this.matSort;
             // this.item =  this.dataSource.data;

          }
        }
        
      }
    }
  
  }

  //failureResp - failure handler
  stockAnalysisFailureResp(res: any) {
    if (res.error) {
    } else {
      alert(res.message);
    }
    
  }
  
  ngAfterViewInit(): void {
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }

  filterCategory() {
    const category = this.categories.find((category: any) => category.cid == this.selectedFilter.categoryID);
    this.selectedFilter.category = category.cnm;
    if(category?.sub) {
      this.subCategories = category.sub;
      this.selectedFilter.subCategoryID = 0;
      this.selectedFilter.subCategory = 'All Sub-Categories';
    }    
  }

  filterSubCategory() {
    const subCategory = this.subCategories.find((subCategory: any) => subCategory.sid == this.selectedFilter.subCategoryID);
    this.selectedFilter.subCategory = subCategory.snm;
  }

  //common search
  applyFilter(type?: string) {
    let filteredItems = this.origStockData;
    
    if(this.selectedFilter.categoryID != 0) {
      if(type == 'category') {
        this.filterCategory();
      }
      filteredItems = filteredItems.filter((item: any) => item.CategoryID == this.selectedFilter.categoryID);
    } else {
      this.subCategories = [];
      this.selectedFilter.subCategoryID = 0;
      this.selectedFilter.subCategory = 'All Sub-Categories';
    }
    
    if(this.selectedFilter.subCategoryID != 0) {
      this.filterSubCategory();
      filteredItems = filteredItems.filter((item: any) => item.SubCategoryID == this.selectedFilter.subCategoryID);
    }

    if(this.selectedFilter.importanceID != 3) {
      filteredItems = filteredItems.filter((item: any) => item.ImportanceID == this.selectedFilter.importanceID);
    }

    if(this.selectedFilter.stockLevelSel) {
      filteredItems = filteredItems.filter((item: any) => item.currentLevel <= this.selectedFilter.stockLevel);
    }

    if(this.selectedFilter.source == 1) {
      filteredItems = filteredItems.filter((item: any) => item.IsMade);
    }

    if(this.selectedFilter.source == 2) {
      filteredItems = filteredItems.filter((item: any) => item.IsPurchased);
    }

    if(this.selectedFilter.type != 0) {
      filteredItems = filteredItems.filter((item: any) => item.TypeID == this.selectedFilter.type);
    }

    this.dataSource.data = filteredItems;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  searchFilter(event: Event) {
    let searchString = (event.target as HTMLInputElement).value;
    this.dataSource.filter = searchString.trim().toLowerCase();
  }

//export to excel
exportToExcelActivities() {
      var html = "";
      html += "<table><tr>";
      html += "<th style='text-align: left;'>"+ this.reportTitle +"</th>"
      html += "</table></tr>";
      html += "<table><tr></table></tr>";

      if (this.period == 1) {
        var  monthlist = this.months.filter((a: any) => a.number == this.view.month && a.year == this.view.year);
          if (monthlist.length > 0) {
              html += "<p><b>Month : </b>" + monthlist[0].display + "</p>"
          }
      }
      else if (this.period == 2) {
        monthlist = this.months.filter((a: any) => a.number == this.view.month && a.year == this.view.year);
        if (monthlist.length > 0) {
            html += "<p><b>Month : </b>" + monthlist[0].display + "</p>"
        }
      }
      else if (this.period == 3) {
        html += "<p><b>Fin Years: </b>" + this.view.fy + "</p>"
    }        
      
      html += "</table></tr>";
      html += "</table></tr>";
      
      if(this.period == 5){
      html += "<p><b>  Month : </b>"+ this.monthDisplay +  "</p>"
      }

      // Blank Column
      html += "<table><tr></table></tr>";
      html += "<table><tr>";

  var strHeader = ""
  strHeader += "<th style='text-align: left;'>Item</th>";
  strHeader += "<th style='text-align: right;'>Min Qty</th>";
  strHeader += "<th style='text-align: right;'>Orders</th>";
  strHeader += "<th style='text-align: right;'>Stock</th>";
  strHeader += "<th style='text-align: right;'>PO</th>";
  strHeader += "<th style='text-align: right;'>WIP</th>";
  strHeader += "<th style='text-align: right;'>Shortfall</th>";
  strHeader += "<th style='text-align: left;'>Unit</th>";
  strHeader += "<th style='text-align: right;'>Level</th>";
  strHeader += "<th style='text-align: left;'>Lead Time</th>";

  strHeader += "</tr>"

  html += strHeader;

  var body = "";
  this.exportToExcel.forEach((stockAnalysisData:any, key:any) => {
    body += "<tr>";
    body += "<td style='text-align: left;'>" + stockAnalysisData.ItemName + "</td>";
    body += "<td style='text-align: right;'>" + stockAnalysisData.minStock + "</td>";
    body += "<td style='text-align: right;'>" + stockAnalysisData.pndgSOQty + "</td>";
    body += "<td style='text-align: right;'>" + stockAnalysisData.currentStock + "</td>";
    body += "<td style='text-align: right;'>" + stockAnalysisData.pndgPOQty + "</td>";
    body += "<td style='text-align: right;'>" + stockAnalysisData.pndgPrdJobQty + "</td>";
    body += "<td style='text-align: right;'>" + (stockAnalysisData.hasDiffUnits ? '?' : (stockAnalysisData.shortfall <= 0 ? '-' : stockAnalysisData.shortfall)) + "</td>";
    body += "<td style='text-align: left;'>" + (stockAnalysisData.hasDiffUnits ? '?' : stockAnalysisData.SKU) + "</td>";
    body += "<td style='text-align: right;'>" + (stockAnalysisData.hasDiffUnits ? '?' : (stockAnalysisData.minStock == 0 ? '-' : stockAnalysisData.currentLevel + ' %')) + "</td>";
    body += "<td style='text-align: left;'>" + (stockAnalysisData.leadTime > 1 ? stockAnalysisData.leadTime + ' days' : stockAnalysisData.leadTime + ' day') + "</td>";
    
  body += "</tr>";
  })

 
  html += body;
  html += "</table>";
  this.tableToExcel(html, 'Sheet1', this.reportTitle);
}

// modalReference: any;
// open(content: any) {
//   this.modalReference = this.modalService.open(ProductionJobCreationComponent, { windowClass: 'productionEntry', backdrop: 'static', keyboard: false });
//   this.modalReference.componentInstance.mdlRef = this.modalReference;
//   this.modalReference.componentInstance.prTypeID = 1;

//   this.modalReference.result.then((result: any) => {

//     if (result.action == 'Done') {
//       //this.getWIPNos();
//       let Wip = JSON.parse(result.obj.updatePackage);
//       console.log(result);

//       //this.Edit("", Wip.Table[0].JobID);

//     }
//   })
// }


  backBtn() {
    this.router.navigate(['/Stock']);
  }

  refresh() {
    window.location.reload();
  }

  openItemSummary(obj: any) {
    let target: string = this.isWeb ? "_blank" : '_self';
    window.open('/ERP/ItemSummary?IID=' + obj.ItemID , target, 'height = 600, width = 1250');
  }

  openPO() {
    window.location.href = '/main.html#/DocBuilder?isN=' + encodeURIComponent('1') + '&Type=' + encodeURIComponent('Purchase Order');
  }
}
